module.exports = __webpack_public_path__ + "assets/0cda9ba1d488bea97f7639a87f4284f3.mp3";